import { useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";

export function useUsername() {
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  const localStorageKey = "currentUsername";
  const [userName, setUserName] = useState<string | undefined>(localStorage.getItem(localStorageKey) ?? undefined);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    instance.initialize().then(() => {
      setInitialized(true);
    });
  }, [instance]);

  useEffect(() => {
    if (initialized == false) {
      return;
    }

    if (isAuthenticated) {
      const updatedUserName = instance.getActiveAccount()!.username;
      localStorage.setItem(localStorageKey, updatedUserName);

      if (userName !== updatedUserName) {
        setUserName(updatedUserName);
      }
      return;
    }

    if (userName === undefined && location.pathname !== "/login") {
      navigate("/login");
    }
  }, [initialized, instance, isAuthenticated, location.pathname, navigate, userName]);

  return userName;
}
